// defs
import { ISimulationInput } from "@defs/Utilities";
import { InputType } from "@utils/appsync/schema/API";
import { IStepper } from "@components/Stepper/Stepper.props";

export enum OpexAllocationSteppersType {
    ADD_DEFINIIONS_AND_MAPPINGS = "ADD_DEFINIIONS_AND_MAPPINGS",
    VIEW_EDIT_DRIVERS = "VIEW_EDIT_DRIVERS",
    REVIEW_AND_RUN = "REVIEW_AND_RUN",
}

export const OPEX_ALLOCATION_STEPPERS: Array<IStepper<OpexAllocationSteppersType>> = [
    {
        key: "ADD_DEFINIIONS_AND_MAPPINGS",
        label: "Add Definitions and/or Mappings",
        position: 0,
        type: OpexAllocationSteppersType.ADD_DEFINIIONS_AND_MAPPINGS,
        hasNext: true,
        enableNext: false,
        hasBack: false,
        isComplete: false,
        isActive: true,
        isSkip: false,
        isVisible: true,
    },
    {
        key: "VIEW_EDIT_DRIVERS",
        label: "View/Edit Drivers",
        position: 1,
        type: OpexAllocationSteppersType.VIEW_EDIT_DRIVERS,
        hasNext: true,
        enableNext: true,
        hasBack: false,
        isComplete: false,
        isActive: false,
        isSkip: true,
        isVisible: true,
    },
    {
        key: "REVIEW_AND_RUN",
        label: "Review & Run",
        position: 2,
        type: OpexAllocationSteppersType.REVIEW_AND_RUN,
        hasNext: false,
        enableNext: false,
        hasBack: false,
        isComplete: false,
        isActive: false,
        isSkip: false,
        isVisible: true,
    },
];

export const OPEX_ALLOCATION_SIMULATION_INPUTS: Array<ISimulationInput<InputType>> = [
    {
        inputId: 0,
        inputLabel: "Definitions",
        inputKey: InputType.allocation_definition,
        systemSelection: true,
    },
    {
        inputId: 1,
        inputLabel: "Mappings",
        inputKey: InputType.allocation_mapping,
        systemSelection: false,
    },
];

export const EMPTY_STATE_COST_POOL_MESSAGE = "All costpools in simulation use standard drivers. Calculations performed automatically";
